import { MapperType } from "./MapperType";

export const mapperKeys = {
	[MapperType.loading]: [
		"desc",
		"move_order",
		"packaging",
		"pallet_number",
		"units",
		"weight",
		"box_weight",
		"optional",
		"custom",
	],
	[MapperType.unloading]: [
		"desc",
		"move_order",
		"move_order_2",
		"production",
		"pallet_number",
		"units",
		"weight",
		"box_weight",
		"optional",
		"custom",
	],
	[MapperType.loading_unloading_cc]: [
		"desc",
		"move_order",
		"move_order_2",
		"packaging",
		"production",
		"pallet_number",
		"units",
		"weight",
		"box_weight",
		"optional",
		"custom",
	],
	[MapperType.order_import]: [
		"terminal_name",
		// "customer_name",
		"reference",
		"service_name",
		"trip_number",
		"eta_date",
		"eta_time",
		"etd_date",
		"etd_time",
		"eta_truck",
		"eta_trailer",
		"etd_truck",
		"etd_trailer",
		"eta_driver",
		"etd_driver",
		"eta_driver_phone",
		"etd_driver_phone",
		"port_in_name",
		"port_out_name",
		"area_name",
		"pallets",
		"kilos",
		"boxes",
		"loading_order",
		"notes",
	],
};

export const optionalMapperKeys = {
	[MapperType.loading]: ["desc", "packaging", "optional", "custom"],
	[MapperType.unloading]: ["move_order_2", "optional", "custom"],
	[MapperType.loading_unloading_cc]: ["desc", "packaging", "move_order_2", "optional", "custom"],
	[MapperType.order_import]: [
		"terminal_name",
		// "customer_name",
		"reference",
		"service_name",
		"trip_number",
		"eta_date",
		"eta_time",
		"etd_date",
		"etd_time",
		"eta_truck",
		"eta_trailer",
		"etd_truck",
		"etd_trailer",
		"eta_driver",
		"etd_driver",
		"eta_driver_phone",
		"etd_driver_phone",
		"port_in_name",
		"port_out_name",
		"area_name",
		"pallets",
		"kilos",
		"boxes",
		"loading_order",
		"notes",
	],
	[MapperType.none]: [],
};
